export default "__VITE_ASSET__DpPO_WZT__"